import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from "@floating-ui/react";
import { createPortal } from "react-dom";
import { useSelected } from "slate-react";

import { ElementRendererProps } from "./paragraph";
import { Button } from "../../button";
import { useEditorContext } from "../hooks";

const linkAnchorStyles = "text-blue-560 bg-transparent cursor-pointer";

export const Link = ({
  attributes,
  children,
  element,
  readOnly,
  isLinkEnabled,
  renderEditTo,
}: ElementRendererProps<"link"> & {
  renderEditTo?: () => HTMLElement | null | undefined;
}) => {
  const { setModal } = useEditorContext();
  const selected = useSelected();
  const open = !readOnly && selected;
  const popup = useFloating({
    placement: "right",
    open,
    middleware: [
      offset(5),
      shift({ padding: 10 }),
      flip({ fallbackPlacements: ["bottom", "top"] }),
    ],
    whileElementsMounted: autoUpdate,
  });

  const getEditLink = () => {
    const editLink = (
      <span ref={popup.refs.setFloating} style={popup.floatingStyles}>
        <Button
          text="Edit Link"
          variant="secondaryDefault"
          leftIcon="solidEllipsis"
          onMouseDown={() => setModal({ option: "link", element })}
        />
      </span>
    );
    const editRenderContainer = renderEditTo?.();

    return editRenderContainer
      ? createPortal(editLink, editRenderContainer)
      : editLink;
  };

  return (
    <span className="inline-block" ref={popup.refs.setReference}>
      <a
        {...attributes}
        href={isLinkEnabled ? element.url : undefined}
        target="_blank"
        rel="noopener noreferrer"
        className={linkAnchorStyles}
      >
        <span {...attributes}>{children}</span>
      </a>
      {open && getEditLink()}
    </span>
  );
};
